export default class Share {
  initialize() {
    console.debug('== Share links ==')

    const linksLinkedin = document.querySelectorAll('.share-link--linkedin')
    const linksFacebook = document.querySelectorAll('.share-link--facebook')

    linksFacebook.forEach((link) => {
      link.addEventListener('click', () => {
        const url =
          'https://www.facebook.com/sharer/sharer.php?u=' +
          encodeURIComponent(window.location.href)

        this.openSharingWindow(url)
      })
    })

    linksLinkedin.forEach((link) => {
      link.addEventListener('click', () => {
        const url =
          'https://www.linkedin.com/sharing/share-offsite/?url=' +
          encodeURIComponent(window.location.href)

        this.openSharingWindow(url)
      })
    })
  }

  openSharingWindow(url) {
    const width = 500
    const height = 400
    const left = window.screen.width / 2 - width / 2
    const top = window.screen.height / 2 - height / 2

    const features = `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes`

    window.open(url, 'socialSharing', features)
  }

  static init() {
    const shareInstance = new Share()
    shareInstance.initialize()
  }
}
